import React from "react";
import { Link } from "react-router-dom";
import { CA_HD_2027_REPORT_PATH } from "../../config/publishedReports";
import { GRIDPLAN_PLAN_PATH } from "../news/GridPlanPlanArticle";

const stories = [
  {
    id: "hd-forecast-2027-2030",
    date: "September 2026",
    category: "Release",
    audience: "For utilities",
    title: "Heavy Duty Charging Forecast for 2027–2030",
    body: "Medium- and heavy-duty EV load is now published for California utility territories through 2030.",
    cta: "Check out the forecast",
    to: CA_HD_2027_REPORT_PATH,
    image: "/img/homepage/cartoonroads.jpeg",
    imageAlt: "Placeholder — HD forecast map",
  },
  {
    id: "gridplan-roadmap",
    date: "October 2026",
    category: "Roadmap",
    audience: "For utilities",
    title: "GridPlan — AmpTrans's upcoming forecasting tool",
    body: "AmpTrans is building GridPlan for utility load forecasting, with insights to help utilities identify and plan infrastructure needs. Read how a forecast is built, and what is available while the tool is in development.",
    cta: "Learn more",
    to: GRIDPLAN_PLAN_PATH,
    image: "/img/homepage/cartoonwarehouse.jpeg",
    imageAlt: "Placeholder — GridPlan forecasting visual",
  },
];

export const LandingNews = () => (
  <section id="news" className="scroll-mt-24 bg-white py-10 md:py-14">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <h2 className="mb-6 text-lg font-semibold uppercase tracking-wider text-blue-700 md:text-xl">
        News
      </h2>

      <div className="grid gap-4 md:grid-cols-2">
        {stories.map((story) => (
          <article
            key={story.id}
            className="flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-slate-50"
          >
            <div className="relative h-40 bg-slate-100 sm:h-44">
              <img src={story.image} alt={story.imageAlt} className="h-full w-full object-cover" />
            </div>
            <div className="flex flex-1 flex-col px-5 py-5 sm:px-6">
              <div className="flex flex-wrap items-center gap-2 text-[11px] font-semibold uppercase tracking-wider">
                <span className="rounded-full bg-teal-50 px-2 py-0.5 text-teal-800">{story.category}</span>
                <span className="text-slate-400">{story.date}</span>
                <span className="text-slate-300">·</span>
                <span className="text-slate-500">{story.audience}</span>
              </div>
              <h3 className="mt-2.5 text-xl font-bold tracking-tight text-slate-900">
                {story.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{story.body}</p>
              <Link
                to={story.to}
                className="mt-4 inline-flex w-fit items-center rounded-lg bg-blue-700 px-4 py-2 text-sm font-semibold text-white transition hover:bg-blue-800"
              >
                {story.cta}
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="ml-1.5">
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
              </Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
